import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    columns: [],
    data: [],
    meta: {},
    links: {},
    loadingStatus: "idle",
    error: null
}

export const fetchPreventive = createAsyncThunk(
    'preventive/fetchPreventive',
    async ({token, page, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            return await request(
                `${APP_URL}/surveys?${page}&${params}`,
                'GET',
                null,
                customHeaders
            );
        } catch (error) {
            rejectWithValue(error);
        }
    }
);

const preventiveSlice = createSlice({
    name: "preventive",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPreventive.pending, (state) => {
                state.loadingStatus = "loading";
                state.columns = null;
                state.data = null;
                state.error = null;
            })
            .addCase(fetchPreventive.fulfilled, (state, action) => {
                state.loadingStatus = "idle";
                state.columns = action.payload.columns;
                state.data = action.payload.data;
                state.links = action.payload.links;
                state.meta = action.payload.meta;
                state.error = null;
            })
            .addCase(fetchPreventive.rejected, (state, action) => {
                state.loadingStatus = "error";
                state.columns = null;
                state.data = null;
                state.links = null;
                state.meta = null;
                state.error = action.payload;
            })
    }
})

export default preventiveSlice.reducer;